module.exports = __webpack_public_path__ + "img/plus.9640eb48.svg";